export default __webpack_public_path__ + "static/media/fondo_banner.a8210ccb.svg";